import Image from "next/image";

import { type FragmentOf, type SiteLocale, readFragment } from "~/lib/graphql";

import * as fragment from "./graphql";

export function ResponsiveImage(props: {
  record: FragmentOf<typeof fragment.responsiveImageFragment>;
  locale: SiteLocale;
}) {
  const record = readFragment(fragment.responsiveImageFragment, props.record);

  return (
    <div className="my-20 flex flex-col items-center justify-center gap-4 md:flex-row">
      <a href="https://lifestockprotect.info/en/" target="_blank" rel="noreferrer">
        <Image
          src={`${record.desktopImage?.url}?w=400&auto=format&dpr=2`}
          width={400}
          height={300}
          alt="lifestockprotect"
        />
      </a>
      <p className="w-full text-sm md:max-w-[40%]">
        {props.locale === "de"
          ? "Das LIFEstockProtect-Projekt (LIFE19 NAT/AT/000889) wird durch das LIFE-Programm der Europäischen Union finanziert. Der Inhalt dieser Videos liegt in der alleinigen Verantwortung von LIFEstockProtect und spiegelt nicht unbedingt die Meinung der Europäischen Union wider. "
          : props.locale === "en"
            ? "The LIFEstockProtect project (LIFE19 NAT/AT/000889) is funded by the LIFE program of the European Union. The content of these videos is the sole responsibility of LIFEstockProtect and does not necessarily reflect the opinion of the European Union. "
            : "Il progetto LIFEstockProtect (LIFE19 NAT/AT/000889) è finanziato dal programma LIFE dell'Unione Europea. Il contenuto di questi video è di esclusiva responsabilità di LIFEstockProtect e non riflette necessariamente l'opinione dell'Unione Europea. "}
      </p>
    </div>
  );
}
